var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"webhookDetailsModal",attrs:{"id":"webhook-details-modal","title":"Webhook Details","hide-footer":"","size":"lg"}},[_c('b-form-group',[_c('label',{staticClass:"col-form-label pt-0"},[_vm._v("\n      Webhook Secret Key\n    ")]),_c('CopyInput',{attrs:{"value":_vm.webhookp.secret_key}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }